import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginRequest, setToken } from './api';

export default function Login() {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token, role } = await loginRequest(mobile, password);
      setToken(token, role);
      navigate('dashboard');
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Invalid mobile number or password, or server unreachable.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-100 px-4">
      <div className="w-full max-w-md rounded-2xl border border-neutral-200 bg-white p-8 shadow-sm">
        <h1 className="mb-1 text-xl font-bold text-neutral-900">Admin</h1>
        <p className="mb-6 text-sm text-neutral-500">
          Sign in with your admin mobile number and password.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <label className="text-sm font-medium text-neutral-700">
            Mobile number
            <input
              type="tel"
              autoComplete="tel"
              inputMode="tel"
              placeholder="+880 1XXX XXX XXX"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="mt-1 w-full rounded-lg border border-neutral-300 px-3 py-2 text-neutral-900 outline-none focus:border-brand-olive focus:ring-1 focus:ring-brand-olive"
              required
            />
          </label>
          <label className="text-sm font-medium text-neutral-700">
            Password
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-lg border border-neutral-300 px-3 py-2 text-neutral-900 outline-none focus:border-brand-olive focus:ring-1 focus:ring-brand-olive"
              required
            />
          </label>
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
          <button
            type="submit"
            disabled={loading}
            className="rounded-lg bg-brand-forest px-4 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
